import { SYSTEM_USER } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import type { WebItemLocationQueryType } from '@confluence/web-item-location/entry-points/WebItemLocationQuery.ts';
import type { GraphQLError } from 'graphql';

export const preloadProfileMenu = ():
	| Promise<void>
	| Promise<{
			data: WebItemLocationQueryType | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }> => {
	return preloadWebItemLocation({ location: SYSTEM_USER });
};
